import { useContext, useState } from 'react';
import { useMutation } from '@apollo/client';
import {
  GET_ALL_PRESTACIONES,
  GET_ALL_PAQUETES,
  UPDATE_PRESTACION_STATUS,
  UPDATE_PAQUETE_STATUS,
} from '../../../Querys/prestaciones/querys';
import { WarningAlert } from '../../../alerts/WarningAlert';
import { ErrorAlert } from '../../../alerts/errorAlert';
import { startglobalLoading } from '../../../context/PrestacionesContext/Actions';
import { AdminContext } from '../../../context/AdminContext/AdminContext';

interface UseUpdatePrestacionStatusParams {
  activa: string;
  paquetes: any[];
  dispatch?: any;
}

const useUpdatePrestacionStatus = ({ activa, paquetes, dispatch }: UseUpdatePrestacionStatusParams) => {
  const [isUpdating, setIsUpdating] = useState(false);
  const { adminState } = useContext(AdminContext);
  const idUsuario = adminState?.id ?? '';

  const [updateStatus] = useMutation(UPDATE_PRESTACION_STATUS, {
    refetchQueries: [{ query: GET_ALL_PRESTACIONES }],
  });
  const [updatePaqueteStatus] = useMutation(UPDATE_PAQUETE_STATUS, {
    refetchQueries: [{ query: GET_ALL_PAQUETES }],
  });

  const updatePrestacionStatus = async (id: any) => {
    let paquetesAfectados: any[] = [];

    if (activa === 'Activo') {
      paquetesAfectados = paquetes.filter(
        (p: any) => p.status === true && p.prestaciones?.some((pr: any) => String(pr.id) === String(id))
      );

      if (paquetesAfectados.length > 0) {
        const nombres = paquetesAfectados.map((p: any) => p.nombre).join(', ');
        const result = await WarningAlert({
          text: `La prestación será deshabilitada. Los siguientes paquetes que la contienen también quedarán deshabilitados: ${nombres}. ¿Deseas continuar?`,
          showDenyButton: true,
          confirmButtonText: 'Continuar',
        });
        if (!result?.isConfirmed) return;
      }
    }

    setIsUpdating(true);
    if (dispatch) startglobalLoading(dispatch);
    try {
      // Desactivar primero los paquetes afectados; si algo falla, se propaga al catch
      // para avisar al usuario y no dejar la prestación en un estado inconsistente.
      for (const paquete of paquetesAfectados) {
        await updatePaqueteStatus({ variables: { id: String(paquete.id), idUsuario } });
      }
      await updateStatus({ variables: { id } });
    } catch (e) {
      ErrorAlert({ text: 'Error al actualizar el estatus de la prestación.' });
    } finally {
      setIsUpdating(false);
    }
  };

  return { updatePrestacionStatus, isUpdating };
};

export default useUpdatePrestacionStatus;
